import PropTypes from 'prop-types';

const SVG = ({
  style = {
    fill: '#000000',
  },
}) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 42.45">
    <path d="M39.16 24.43l-.89 1.52a7.9 7.9 0 11-1.48-.72l.56-1.67a9.94 9.94 0 00-3.11-.51 9.7 9.7 0 00-9.69 9.69 9.54 9.54 0 00.68 3.55H19a1.46 1.46 0 01-1.14-2.38l2.92-3.65-.94-.49c-1-.54-1.83-.95-2.61-1.35s-1.66-.83-2.7-1.39l-.83 1.55c1.07.57 1.91 1 2.73 1.41l1.65.84-1.59 2A3.22 3.22 0 0019 38.09h7.15a9.69 9.69 0 1013-13.66z" />
    <path d="M59.94 18.54c-.34-2.11-2.19-4.58-4.81-6.47-.3-.21-.6-.42-.92-.61-.29-2.75-3.48-5.76-8-7.49a17.61 17.61 0 00-6.32-1.21C37.67 1.03 34 0 30 0s-7.67 1-9.88 2.76a17.61 17.61 0 00-6.32 1.21c-4.53 1.73-7.72 4.74-8 7.49-.32.19-.62.4-.92.61C2.25 13.96.4 16.43.06 18.54a3.36 3.36 0 00.52 2.6 3 3 0 001 .9c.13.09 7.06 3.84 7.58 4.11L10 24.6c-.52-.27-7.56-4.1-7.56-4.1a1.38 1.38 0 01-.44-.38 1.78 1.78 0 01-.21-1.3c.27-1.63 1.88-3.72 4.1-5.32.22-.16.45-.31.67-.45l10.57 8.88 1.13-1.34-10.71-9c.25-1.8 2.76-4.39 6.88-6a15.68 15.68 0 015.34-1.1l4.12 13.64 1.68-.51-4.13-13.65C23.35 2.6 26.56 1.76 30 1.76s6.65.84 8.56 2.21L34.41 17.6l1.68.51 4.14-13.59a15.68 15.68 0 015.34 1.1c4.12 1.57 6.63 4.17 6.88 6l-10.66 9.09 1.15 1.34 10.5-9 .67.45c2.22 1.6 3.83 3.69 4.1 5.32a1.75 1.75 0 01-.21 1.29 1.3 1.3 0 01-.47.39s-10.12 5.47-13.07 7l.82 1.56 13.08-7 .07-.05a3 3 0 001-.88 3.36 3.36 0 00.52-2.6z" />
    <path d="M33.25 28.48l-.39-1.71a6.16 6.16 0 00-4.54 7.78l1.69-.5a4.2 4.2 0 01-.19-1.27 4.44 4.44 0 013.43-4.3z" />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object.isRequired,
};

export default SVG;
